import React, { useEffect, useState } from "react"
import Typography from "@mui/material/Typography"
import { useInfoStore } from "../store/userInfo";
import { Box, List, ListItem, Modal } from "@mui/material";
// import { useQuery, useQueryClient } from "@tanstack/react-query";
import { primary, black } from "../theme/colors";
import { ITables } from "../types/store";
import { isBrowser } from 'react-device-detect';
import _ from "lodash";
import { useMenuStore } from "../store/menuState";
import { Axios } from "../api/axios";
import { getTables } from "../services/setting.service";

const OrderbookModal = (props: { openOrderbook: any; setOpenOrderbook: any; }) => {
  const { openOrderbook , setOpenOrderbook} = props;
  const { tableInfo, userInfo, setTableInfo } = useInfoStore();
  const { setSelectedTable } = useMenuStore();
  const storeId = userInfo?.storeId;
  const [loadTables, setLoadTables] = useState([])

  // const handleOpen = () => setOpenOrderbook(true);
  const handleClose = () => setOpenOrderbook(false);

  useEffect(() => {
    getTables(storeId!).then(
      res => {
        setLoadTables(res.data)
      }
    )
  }, [])

  const checkSelectTable = (item: ITables) => {
    if(!tableInfo) return false
    return _.isEqual(item.id,tableInfo!.id) ? true: false
  }

  const handleSelectTable = (item: ITables) => {
    setTableInfo(item)
    setSelectedTable(item)
    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined){
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
    setTimeout(
      function() {
        setOpenOrderbook(false)
      }
    , 300)

  };
  if(!loadTables) return <></>
  return (
    <Modal
      disableAutoFocus
      disableScrollLock
      disableEnforceFocus
      disableRestoreFocus
      open={openOrderbook}
      onClose={handleClose}
      aria-labelledby="modal-orderbook"
      aria-describedby="modal-quick-orderbook"
      sx={{ //You can copy the code below in your theme
        background: 'rgba(0,0,0,0.5)',
        '& .MuiBackdrop-root': {
          backgroundColor: 'transparent' // Try to remove this to see the result
        }
      }}
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h1" component="h2" sx={{textAlign: 'center'}}>
          ORDER BOOK
        </Typography>
        <Box sx={[orderbox, { width: '100%', backgroundColor: '#F0F0F0', mt: '1.8rem', height: '48.0rem' }]}>
          <List style={{ overflow: "overlay", overflowX: 'hidden', display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
              {loadTables!.map((item: ITables, index: number) => {
                return(
                  <ListItem key={index} sx={[{ m: '1.2rem', borderRadius: '6.0rem', width: "auto", minWidth: '6rem', height: '6rem', display: 'inline-flex',justifyContent: 'center', alignItems: 'center', px: '1.8rem', whiteSpace: "normal"},
                    checkSelectTable(item) ? {backgroundColor: primary.main}: item.isKioskMode ? {backgroundColor: '#000'}:{backgroundColor: '#fff'}]} onClick={() => handleSelectTable(item)}>
                    <Typography sx={[checkSelectTable(item)||item.isKioskMode ? {color: '#fff', fontWeight: '600', fontSize: '2.0rem', lineHeight: 'normal'}: {color: black.main, fontSize: '2.0rem'},
                    { textAlign: 'center', alignItems: 'center', textTransform: 'none', whiteSpace : 'nowrap'}]}>{item.tableName}</Typography>
                  </ListItem>)
                })}
          </List>
        </Box>
      </Box>
    </Modal>
  )
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90.0rem',
  height: '60.0rem',
  bgcolor: 'background.paper',
  // border: '2rem solid #000',
  borderRadius: '1.5rem',
  boxShadow: '0rem 0rem 5.0rem 0rem rgba(0, 0, 0, 0.40)',
  p: 4,
};

 const orderbox = {
	display: 'inline-flex',
	padding: '2.6rem 3.0rem',
	flexDirection: 'column',
	alignItems: 'flex-start',
	gap: '1.0rem',
	borderRadius: '1.5rem',
	background: '#F4F4F4',
}
export default OrderbookModal
